import { connect } from 'react-redux'
import Lister from '../../components/Lister/Lister'
import { contentAreaSelector, seoContentAreaSelector, dfpSelector } from '../../selectors/content'
import { allProductsSelector } from '../../selectors/product'

const mapStateToProps = state => ({
  products: allProductsSelector(state),
  contentAreas: contentAreaSelector(state),
  seoArea: seoContentAreaSelector(state),
  dfp: dfpSelector(state)
})

export default connect(mapStateToProps)(Lister)
